import { render, staticRenderFns } from "./ShadowBox.vue?vue&type=template&id=780da814&scoped=true&"
import script from "./ShadowBox.vue?vue&type=script&lang=js&"
export * from "./ShadowBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780da814",
  null
  
)

export default component.exports